import { Stack, styled } from '@mui/material'
import Divider from '@mui/material/Divider'
import { Button } from '../../../../components'

const Container = styled(Stack)`
  padding: 16px;
  position: relative;
`

const ScrollContainer = styled(Stack)`
  position: relative;
  overflow-y: auto;
  max-height: 200px;
  gap: 8px;
  margin: 8px 0;
`

const LoaderContainer = styled(Stack)`
  padding: 24px;
  align-items: center;
  justify-content: center;
  min-height: 20px;
`

const EmptyStateWrapper = styled(Stack)`
  gap: 8px;
  flex-direction: row;
  align-items: center;
`

const HorizontalLine = styled(Divider)(({ theme }) => ({
  position: 'absolute',
  borderStyle: 'dashed',
  borderColor: theme.palette.customGrey.three,
  width: '32px',
  right: '-32px',
}))

const DashedVerticalLine = styled(Divider)(({ theme }) => ({
  borderStyle: 'dashed',
  borderColor: theme.palette.customGrey.three,
  height: '100%',
  margin: 0,
  position: 'absolute',
  width: '2px',
  right: '44px',
}))

const ButtonWrapper = styled(Stack)`
  justify-content: center;
  align-items: flex-end;
`

const GroupButton = styled(Button)`
  width: 200px;
  height: 44px;
`

const EditIconContainer = styled('div')`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  width: 24px;
  height: 24px;
  border-radius: 3px;
  cursor: pointer;
  transform: translate(-50%, -50%);
  border: 1px solid ${({ theme }) => theme.palette.customGrey.three};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;
`

const DeliveryItemWrapper = styled(Stack)`
  position: relative;
  justify-content: center;
  margin-right: 80px;
`

export {
  Container,
  ScrollContainer,
  LoaderContainer,
  EmptyStateWrapper,
  HorizontalLine,
  DashedVerticalLine,
  ButtonWrapper,
  GroupButton,
  EditIconContainer,
  DeliveryItemWrapper,
}
